import {
    GridRowModes,
    DataGrid,
    GridActionsCellItem,
    GridRowEditStopReasons,
} from '@mui/x-data-grid';
import { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';

import calLoader from '../assets/images/calendar-loader.svg';

const StyledGridOverlay = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    backgroundColor: 'rgba(18, 18, 18, 0.9)',
    ...theme.applyStyles('light', {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
    }),
}));

const CustomLoadingOverlay = () => {
    return (
        <StyledGridOverlay>
            <img src={calLoader} className="cal-loader" />
        </StyledGridOverlay>
    );
}

export const DataGridMUI = ({ columns, rows, isLoading, rowModesModel, onRowModesModelChange, processRowUpdate, pageNumber,
    setPageNumber, pageSize, setPageSize, totalRecord }) => {

    const [gridTranslationsLocaleText, setGridTranslationsLocaleText] = useState(null);
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);

    useEffect(() => {
        if (reduxLanguageTranslations) {
            let gridTranslationObj = {
                // Column menu text
                columnMenuUnsort: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuUnsort"] : "columnMenuUnsort",
                columnMenuSortAsc: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuSortAsc"] : "columnMenuSortAsc",
                columnMenuSortDesc: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuSortDesc"] : "columnMenuSortDesc",
                columnMenuFilter: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuFilter"] : "columnMenuFilter",
                columnMenuHideColumn: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuHideColumn"] : "columnMenuHideColumn",
                columnMenuShowColumns: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuShowColumns"] : "columnMenuShowColumns",
                columnMenuLabel: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnMenuLabel"] : "Menu",
                columnHeaderSortIconLabel: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridColumnHeaderSortIconLabel"] : "Sort",

                // Filter panel text
                filterPanelDeleteIconLabel: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterPanelDeleteIconLabel"] : "Delete",
                filterPanelOperator: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterPanelOperator"] : "Operator",
                filterPanelColumns: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterPanelColumns"] : "Columns",
                filterPanelInputLabel: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterPanelInputLabel"] : "Value",
                filterPanelInputPlaceholder: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterPanelInputPlaceholder"] : "Filter value",

                // Filter operators text
                filterOperatorContains: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorContains"] : "contains",
                filterOperatorDoesNotContain: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorDoesNotContain"] : "does not contain",
                filterOperatorEquals: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorEquals"] : "equals",
                filterOperatorDoesNotEqual: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorDoesNotEqual"] : "does not equal",
                filterOperatorStartsWith: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorStartsWith"] : "starts with",
                filterOperatorEndsWith: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorEndsWith"] : "ends with",
                filterOperatorIsEmpty: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorIsEmpty"] : "is empty",
                filterOperatorIsNotEmpty: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorIsNotEmpty"] : "is not empty",
                filterOperatorIsAnyOf: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridFilterOperatorIsAnyOf"] : "is any of",

                noRowsLabel: reduxLanguageTranslations != null ? reduxLanguageTranslations["noAgentFound"] : 'No agent found',

                // Used table pagination translation keys
                MuiTablePagination: {
                    getItemAriaLabel: (type) => {
                        if (type === 'first') {
                            return reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridGoToFirstPageBtnLabel"] : "Go to first page";
                        }
                        if (type === 'last') {
                            return reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridGoToLastPageBtnLabel"] : "Go to last page";
                        }
                        if (type === 'next') {
                            return reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridGoToNextPageBtnLabel"] : "Go to next page";
                        }
                        return reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridGoToPreviousPageBtnLabel"] : "Go to previous page";
                    },
                    labelRowsPerPage: reduxLanguageTranslations != null ? reduxLanguageTranslations["muiDataGridLabelRowsPerPage"] : "Rows per page:",
                }
            }
            setGridTranslationsLocaleText(gridTranslationObj);
        }
    }, [reduxLanguageTranslations])
    
    return (
        <>
            <DataGrid
                rows={rows}
                columns={columns}
                rowCount={totalRecord}
                editMode="row"
                paginationMode="server"
                rowModesModel={rowModesModel}
                onRowModesModelChange={onRowModesModelChange}
                processRowUpdate={processRowUpdate}
                paginationModel={{ page: pageNumber, pageSize: pageSize }}
                onPaginationModelChange={(newModel) => {
                    setPageNumber(newModel.page);
                    setPageSize(newModel.pageSize);
                }}
                pageSizeOptions={[25, 50, 100]}
                disableRowSelectionOnClick
                onRowEditStop={(params, event) => {
                    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
                        event.defaultMuiPrevented = true;
                    }
                }}
                localeText={gridTranslationsLocaleText} // multi-legul language
                loading={isLoading}
                slots={{
                    loadingOverlay: CustomLoadingOverlay,
                }}
                disableColumnMenu   // hide column menu (3-dot icon)

                //getRowClassName={(params) =>
                //    params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row-waiting-grid' : 'odd-row-waiting-grid'
                //}
            />
        </>
    )

}